
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';
// noinspection CssUnknownTarget

import api from "@/api/";
import {getToken} from "@/utils/cookie";
import proxyFile from "../../../proxy";
import {dynamicLog} from "@/utils/dynamicLog";
import {MULTILINGUALNAMESLIST} from "@/utils/enum";
import {
  handlerImgSize,
  downloadControl,
  isJSON,
  qs,
  commonSessionStorage,
  commonLocalStorage,
  checkUserBalance,
  isValueEmpty,
  _handleMultilingualFields,
  pageJump,
  getRouteMenuKey,
  getWarehouseId,
  getSetLanguages,
  printHtmlUrl,
  getFullImagePath,
  setConfigCharacters
} from "@/utils/common";

export default {
  data() {
    return {
      sixIemCol: {
        // 头部筛选区域划分为六等分
        span: 4
      },
      fourItemCol: {
        // 头部筛选区域划分为四等分
        span: 6
      },
      threeItemCol: {
        // 头部筛选区域划分为三等分
        span: 8
      },
      twoItemCol: {
        // 头部筛选区域划分为二等分
        span: 12
      },
      oneItemCol: {
        // 头部筛选区域划分为一等分
        span: 24
      },
      headObj: {
        Authorization: getToken()
      },
      imageFormatList: ["image/png", "image/webp", "image/bmp", "image/jpeg", "image/jpg"],
      domWidth: document.documentElement.clientWidth || document.body.clientWidth || 0,
      domHeight: document.documentElement.clientHeight || document.body.clientHeight || 0,
      offsetCol: 1,
      gutterItem: 16, // 栅格间距，单位 px，左右平分
      moreFilter: false, // 高级筛选
      moreFilterIcon: "md-arrow-dropdown",
      storeFilterMes: "",
      moreFilterMes: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000133'),
      tableLoading: false, // 列表的loading变量
      pageArray: [10, 15, 20, 50, 100], // 每页条数切换的配置
      filenodeViewTargetUrl: this.$store.state.erpConfig ? this.$store.state.erpConfig.filenodeViewTargetUrl : "",
      LogisticsProviderData: [], // 物流商数据
      LogisticsProviderModeData: [], // 物流商的邮寄方式数据
      system: localStorage.getItem("system"), // 展示当前系统的标识  yms系统：yms   供应商系统：supplier
      isAdmin: commonSessionStorage.getItem("isAdmin") || this.$store.state.isAdmin, // 管理员
      failPlaceholder: require("@/assets/images/imageFail.jpg"),
      dateOptions: {
        shortcuts: [
          {
            text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000134'), value: function () {
              let end = new Date();
              let start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              return [start, end];
            }
          },
          {
            text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000135'), value: function () {
              let end = new Date();
              let start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              return [start, end];
            }
          },
          {
            text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000136'), value: function () {
              let end = new Date();
              let start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              return [start, end];
            }
          }
        ]
      },
      uploadFilesMaxSize: 10240, // 上传文件大小上线（kb）
      shippingMethodModel: [],
      shippingMethodData: [],
      // 云卖分类自定义字段名
      normalizer(node) {
        return {
          id: node.ymsProductCategoryId,
          label: node.title, children:
          node.children
        };
      },
      // 商品服务
      productServiceList: [
        {value: 1, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000137')}
      ],
      shippingAccountModel: [],
      shippingMethodsList: [],
      carrierList: [],
      optionBtnWidth: [],
      languageList: [],
      multilingualNamesList: [],
      addressTemplateData: [],
      viewerOptions: {
        navbar: false, // 是否显示缩略图底部导航栏
        title: false, // 是否显示缩略图标题栏
        zIndex: 9999999,
        toolbar: {
          zoomIn: true, zoomOut: true, oneToOne: true, reset: false, // 隐藏重置按钮
          prev: false, // 隐藏左翻页按钮
          play: false, // 隐藏播放按钮
          next: false, // 隐藏右翻页按钮
          rotateLeft: true,
          rotateRight: true,
          flipHorizontal: true,
          flipVertical: true
        }
      },
      placeholderUrl: require('#@/static/images/placeholder.jpg'),
      noContent: require('@/assets/images/noDataIcon.png'),
    };
  },
  computed: {
    // 判断当前在那个系统 (true: 为供应商系统， false：为运营系统)
    systemTalg() {
      let system = localStorage.getItem("system") || this.$store.state.system;
      if (system.includes("supplier")) {
        return true;
      } else if (system.includes("yms")) {
        return false;
      }
    },
    // 币种
    currencyState() {
      return this.$store.state.currency;
    },
    // 系统设置的语种
    languagesVal() {
      return getSetLanguages();
    },
    // 设置多语种版本的labelWidth
    labelWidth() {
      return this.languagesVal === 'zh-CN' ? 120 : 160;
    },
    // 系统环境(yms 云卖、trs 泰瑞森)
    systemEnvironment() {
      let pageConfig = commonLocalStorage.getItem('pageConfig') || this.$store.state.pageConfig;
      return pageConfig?.systemEnvironment;
    }
  },
  methods: {
    // 获取系统前缀；withSpace 不传则按语种决定是否带尾部空格
    configCharacters(withSpace) {
      return setConfigCharacters(withSpace);
    },
    // 控制上传图片大小
    uploadExceedSize() {
      this.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000138'));
    },
    // 上传文件异常
    uploadFilesError() {
      this.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000139'));
    },
    // 上传文件格式异常
    handleFormatError() {
      this.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000140'));
    },
    /**
     *
     * @date: 2021/8/17 18:57
     * @param ymsProductGoodsIds Array
     * @param originalData 原始数据 Array | Object  对象为多维数组情况
     * @param isGetSpu 是否获取spu Boolean
     * @param isReturnResponse
     * @return copyData 增加了商品信息的原始数据 Array  增加了_productInfo 属性
     * @return isReturnResponse 是否直接返回结果
     * @param isApi 是否引用其他接口
     * @param useApiUrl 接口
     * @param system 是哪个系统使用的 默认是 yms、distributor
     */
    getProductInfoByIds(ymsProductGoodsIds, originalData, isGetSpu = false, isReturnResponse = false, isApi = false, useApiUrl, system) {
      let v = this;
      let copyData = JSON.parse(JSON.stringify(originalData));
      return new Promise((resolve) => {
        let apiUrl = api.post_ymsProductInfo_queryByYmsProductGoodsIds;
        if (isApi) {
          apiUrl = api.post_ymsProductInfo_api_queryByYmsProductGoodsIds;
        }
        apiUrl = useApiUrl || apiUrl;
        v.axios.post(apiUrl, ymsProductGoodsIds).then((response) => {
          if (response.data.code === 0) {
            let data = response.data.datas || [];
            if (data.length > 0) {
              data = v.handleMultilinguaTableFields(data, ["name"]);
              if (isReturnResponse) {
                resolve(data);
              } else {
                if (v.typeOf(copyData) === "object") {
                  copyData.data.forEach((ch) => {
                    let child = ch;
                    copyData.childKey.forEach((param) => {
                      child = child[param];
                    });
                    child.forEach((i) => {
                      data.forEach((j) => {
                        j.name = _handleMultilingualFields(j.name);
                        if (system === "supplier") {
                          j.productGoodsList.forEach((k) => {
                            if (i.productGoodsId === k.productGoodsId) {
                              if (isGetSpu) {
                                i._productInfo = j;
                              } else {
                                let obj = JSON.parse(JSON.stringify(j));
                                i._productInfo = {
                                  ...k, _spuInfo: obj
                                };
                              }
                            }
                          });
                        } else {
                          j.ymsProductGoodsList.forEach((k) => {
                            if (i.ymsProductGoodsId === k.ymsProductGoodsId) {
                              if (isGetSpu) {
                                i._productInfo = j;
                              } else {
                                let obj = JSON.parse(JSON.stringify(j));
                                i._productInfo = {
                                  ...k, _spuInfo: obj
                                };
                              }
                            }
                          });
                        }
                      });
                    });
                  });
                  copyData = copyData.data;
                } else {
                  if (copyData) {
                    if (data) {
                      copyData.forEach((i, index) => {
                        data.forEach((j) => {
                          j.name = _handleMultilingualFields(j.name);
                          if (system === "supplier") {
                            (j.productGoodsList || []).forEach((k) => {
                              if (i.productGoodsId === k.productGoodsId) {
                                if (isGetSpu) {
                                  i._productInfo = j;
                                } else {
                                  let obj = JSON.parse(JSON.stringify(j));
                                  i._productInfo = {
                                    ...k, _spuInfo: obj
                                  };
                                }
                              }
                            });
                          } else {
                            (j.ymsProductGoodsList || []).forEach((k) => {
                              if (i.ymsProductGoodsId === k.ymsProductGoodsId) {
                                if (isGetSpu) {
                                  copyData[index]._productInfo = j;
                                } else {
                                  let obj = JSON.parse(JSON.stringify(j));
                                  copyData[index]._productInfo = {
                                    ...k, _spuInfo: obj
                                  };
                                }
                              }
                            });
                          }
                        });
                      });
                      resolve(copyData);
                    } else {
                      resolve(copyData);
                    }
                  }
                }
                resolve(copyData);
              }
            } else {
              resolve(copyData);
            }
          }
        });
      });
    },
    /**
     *
     * getProductInfoByIds 调整入参
     * @param params 入参
     * @param originalData 原始数据 Array | Object  对象为多维数组情况
     * @param isGetSpu 是否获取spu Boolean
     * @param isReturnResponse
     * @return copyData 增加了商品信息的原始数据 Array  增加了_productInfo 属性
     * @return isReturnResponse 是否直接返回结果
     * @param isApi 是否引用其他接口
     * @param useApiUrl 接口
     * @param system 是哪个系统使用的 默认是 yms、distributor
     */
    getProductInfoByBo(params, originalData, isGetSpu = false, isReturnResponse = false, isApi = false, useApiUrl, system) {
      let v = this;
      let copyData = JSON.parse(JSON.stringify(originalData));
      return new Promise((resolve) => {
        let apiUrl = api.post_ymsProductInfo_queryProductByYmsProductGoodsIds;
        if (isApi) {
          apiUrl = api.post_ymsProductInfo_api_queryProductByYmsProductGoodsIds;
        }
        apiUrl = useApiUrl || apiUrl;
        v.axios.post(apiUrl, params).then((response) => {
          if (response.data.code === 0) {
            let data = response.data.datas || [];
            if (data.length > 0) {
              data = v.handleMultilinguaTableFields(data, ["name"]);
              if (isReturnResponse) {
                resolve(data);
              } else {
                if (v.typeOf(copyData) === "object") {
                  copyData.data.forEach((ch) => {
                    let child = ch;
                    copyData.childKey.forEach((param) => {
                      child = child[param];
                    });
                    child.forEach((i) => {
                      data.forEach((j) => {
                        j.name = _handleMultilingualFields(j.name);
                        if (system === "supplier") {
                          j.productGoodsList.forEach((k) => {
                            if (i.productGoodsId === k.productGoodsId) {
                              if (isGetSpu) {
                                i._productInfo = j;
                              } else {
                                let obj = JSON.parse(JSON.stringify(j));
                                i._productInfo = {
                                  ...k, _spuInfo: obj
                                };
                              }
                            }
                          });
                        } else {
                          j.ymsProductGoodsList.forEach((k) => {
                            if (i.ymsProductGoodsId === k.ymsProductGoodsId) {
                              if (isGetSpu) {
                                i._productInfo = j;
                              } else {
                                let obj = JSON.parse(JSON.stringify(j));
                                i._productInfo = {
                                  ...k, _spuInfo: obj
                                };
                              }
                            }
                          });
                        }
                      });
                    });
                  });
                  copyData = copyData.data;
                } else {
                  if (copyData) {
                    if (data) {
                      copyData.forEach((i, index) => {
                        data.forEach((j) => {
                          j.name = _handleMultilingualFields(j.name);
                          if (system === "supplier") {
                            j.productGoodsList.forEach((k) => {
                              if (i.productGoodsId === k.productGoodsId) {
                                if (isGetSpu) {
                                  i._productInfo = j;
                                } else {
                                  let obj = JSON.parse(JSON.stringify(j));
                                  i._productInfo = {
                                    ...k, _spuInfo: obj
                                  };
                                }
                              }
                            });
                          } else {
                            j.ymsProductGoodsList.forEach((k) => {
                              if (i.ymsProductGoodsId === k.ymsProductGoodsId) {
                                if (isGetSpu) {
                                  copyData[index]._productInfo = j;
                                } else {
                                  let obj = JSON.parse(JSON.stringify(j));
                                  copyData[index]._productInfo = {
                                    ...k, _spuInfo: obj
                                  };
                                }
                              }
                            });
                          }
                        });
                      });
                      resolve(copyData);
                    } else {
                      resolve(copyData);
                    }
                  }
                }
                resolve(copyData);
              }
            } else {
              resolve(copyData);
            }
          }
        });
      });
    },
    
    // 页码改变的回调，返回改变后的页码
    changePage(page) {
      let v = this;
      v.curPage = Number(page);
      v.pageParams.pageNum = Number(page);
      v.$nextTick(() => {
        v.tableLoading = true;
        v.pageParamsStatus = true;
      });
      v.$forceUpdate();
    },
    // 切换每页条数时的回调，返回切换后的每页条数
    changePageSize(pageSize) {
      let v = this;
      v.pageParams.pageSize = pageSize;
      v.$nextTick(() => {
        v.tableLoading = true;
        v.pageParamsStatus = true;
        v.setPageSizeStorage(pageSize);
      });
    },
    setPageSizeStorage(pageSize) {
      let v = this;
      let htmlName = window.location.href.replace(/.*\/(.*?)\.html.*/, "$1");
      let path = v.$route.path;
      let _pageSizeJson = localStorage.getItem("ymsPageSize");
      let obj = {};
      if (_pageSizeJson) {
        try {
          obj = JSON.parse(_pageSizeJson);
        } catch (e) {
          console.log(e);
          obj = {};
        }
      }
      obj[htmlName + path] = pageSize;
      localStorage.setItem("ymsPageSize", JSON.stringify(obj));
    },
    getPageSizeStorage() {
      let v = this;
      let htmlName = window.location.href.replace(/.*\/(.*?)\.html.*/, "$1");
      let path = v.$route ? v.$route.path : "";
      let _pageSizeJson = localStorage.getItem("ymsPageSize");
      let pageSize = 20;
      if (_pageSizeJson) {
        try {
          let page = JSON.parse(_pageSizeJson)[htmlName + path];
          if (page) {
            pageSize = page;
          }
        } catch (e) {
          console.log(e);
          pageSize = 20;
        }
      }
      if (v.pageParams) {
        v.pageParams.pageSize = pageSize;
      }
    },
    // 中英文逗号分隔, 默认的分隔符：[',', '，', '\n', '；', ';', '.', '、']
    sepCommasFn(params, separators = [",", "，", "\n", "；", ";", ".", "、"]) {
      let arr = [];
      if (params) {
        // 定义分隔符
        let currentCell = "";
        for (let i = 0; i < params.length; i++) {
          const char = params[i];
          if (separators.includes(char)) {
            // 如果是分隔符，则将当前单元格添加到结果数组中，并重置当前单元格
            if (currentCell.trim() !== "") {
              arr.push(currentCell.trim());
              currentCell = "";
            }
          }
          // 如果不是分隔符，则将字符添加到当前单元格
          else {
            currentCell += char;
          }
        }
        if (currentCell.trim() !== "") {
          arr.push(currentCell.trim());
        }
      }
      return arr;
    },
    // 设置列表展示图片的链接地址
    setImgPath(path, serviceType, imgSize, isTableImg, thumbnail = true) {
      if (!path) {
        return this.placeholderUrl;
      }
      const fullPath = getFullImagePath(path, serviceType, thumbnail);
      return thumbnail ? this.getThumbnailImage(fullPath, "/thumb/", imgSize, isTableImg) : fullPath;
    },
    // 列表展示商品信息的公共处理方法
    tableProductInformation(h, params) {
      let v = this;
      let imgPath = "";
      let _productInfo = params.row._productInfo;
      if (_productInfo) {
        let spec = "";
        let skuImgPath = _productInfo.primaryImage;
        let spuImgPath = _productInfo._spuInfo.primaryImage;
        imgPath = skuImgPath ? skuImgPath : spuImgPath;
        let name = _productInfo._spuInfo.name;
        if (_productInfo.productGoodsSpecificationList) {
          spec = _productInfo.productGoodsSpecificationList
            .map((i) => i.name + "：" + i.value)
            .join("、");
        }
        return h("div", {
          class: "flex ptb10"
        }, [v.tableImg(h, params, null, imgPath), h("div", {
          class: "text-align-left pl10"
        }, [h("p", {class: "mb5 color-333"}, `${v.configCharacters(false)}SKU：` + _productInfo.ymsSku), (_productInfo._spuInfo && name) || h("p", {
          attrs: {
            title: name
          }, class: "text-over-line3 mb5 color-666"
        }, name), h("p", {
          class: "color-green"
        }, spec)])]);
      }
    },
    // 列表展示图片的公共处理方法
    tableImg(h, params, imgKey, imgSrc, clickHandel, placement = "left", disabled = false, isTableImg = true) {
      let v = this;
      let imgUrl = imgSrc || params.row[imgKey] || "";
      return h("tooltip", {
        props: {
          placement: placement, theme: "light", maxWidth: 350, transfer: true, disabled: disabled || !imgUrl
        }, style: {
          width: "64px", height: "64px", objectFit: "cover", verticalAlign: "middle"
        }
      }, [h("div", {}, [h("img", {
        attrs: {
          src: v.setImgPath(imgUrl, null, "70x70", isTableImg, isTableImg), /* onerror:
           "javascript:this.src='./static/images/placeholder.jpg'"*/
        }, style: {
          width: "64px", height: "64px", objectFit: "cover", verticalAlign: "middle", cursor: "pointer", padding: "3px"
        }, on: {
          click() {
            clickHandel && clickHandel();
          }, error(event) {
            event.target.src = v.placeholderUrl;
          }
        }
      })]), h("img", {
        slot: "content", props: {}, attrs: {
          src: v.setImgPath(imgUrl)
        }, on: {
          load(event) {
            if (event.path) {
              let dom = event.path[0];
              let imgWdith = 0;
              let imgHeight = 0;
              if (dom) {
                imgWdith = dom.naturalWidth;
                imgHeight = dom.naturalHeight;
                let obj = handlerImgSize(imgWdith, imgHeight);
                dom.style.width = obj.width;
                dom.style.height = obj.height;
                dom.style.verticalAlign = obj.verticalAlign;
              }
            }
            // 兼容火狐浏览器
            else {
              let dom = event.target;
              let imgWdith = dom.naturalWidth || 0;
              let imgHeight = dom.naturalHeight || 0;
              let obj = handlerImgSize(imgWdith, imgHeight);
              dom.style.width = obj.width;
              dom.style.height = obj.height;
              dom.style.verticalAlign = obj.verticalAlign;
            }
          }
        }
      })]);
    },
    // 图片加载完成后的处理方法
    handlerOnloadImg(dom) {
      let v = this;
      let talg = v.$refs[dom];
      if (talg) {
        let talgList = null;
        if (Array.isArray(talg)) {
          talgList = [...talg];
        } else {
          talgList = [talg];
        }
        if (talgList.length > 0) {
          talgList.map((item) => {
            let imgWdith = item.naturalWidth;
            let imgHeight = item.naturalHeight;
            let obj = handlerImgSize(imgWdith, imgHeight);
            item.style.width = obj.width;
            item.style.height = obj.height;
            item.style.verticalAlign = obj.verticalAlign;
            v.$forceUpdate();
          });
        }
      }
    },
    // 回到顶部
    scrollTopFun() {
      const app = document.querySelector('#app');
      if (app) {
        app.scrollTop = 0;
      }
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    },
    /**
     * @Description: 根据数组中的某个属性去重
     * @author jing
     * @date 2021/3/11 18:02
     * @params:
     */
    uniqueFunc(...args) {
      const paramsLength = arguments.length;
      if (paramsLength === 1) {
        let arr = arguments[0];
        return [...new Set(arr)];
      } else {
        const res = new Map();
        const flag = arguments[1];
        return arguments[0].filter((item) => !res.has(item[flag]) && res.set(item[flag], item));
      }
    },
    // 获取input的焦点
    getFocus(id) {
      document.getElementById(id).focus();
    },
    /**
     * @Description: 根据数组的属性值进行分组的方法
     * @author jing
     * @date: 2021/3/19 17:08
     * @params: array 数组, fun 遍历的属性值函数, type 根据的属性值
     */
    handerGrouping(array, fun, type, list = "data") {
      let groups = {};
      array.forEach(function (item) {
        let group = JSON.stringify(fun(item));
        groups[group] = groups[group] || [];
        groups[group].push(item);
      });
      let new_arr = [];
      Object.keys(groups).forEach(group => {
        let obj = {};
        let firstItem = groups[group][0];
        // type 是字符串，直接赋值一个属性
        if (typeof type === 'string') {
          obj[type] = firstItem[type];
        }
        // type 是数组，循环赋值多个属性
        else if (Array.isArray(type)) {
          type.forEach(key => {
            obj[key] = firstItem[key];
          });
        }
        obj[list] = groups[group];
        new_arr.push(obj);
      });
      return new_arr;
    },
    // 深拷贝
    deepCopy(data) {
      let v = this;
      let t = v.typeOf(data);
      let o;
      if (t === "array") {
        o = [];
      } else if (t === "object") {
        o = {};
      } else {
        return data;
      }
      if (t === "array") {
        for (let i = 0; i < data.length; i++) {
          o.push(v.deepCopy(data[i]));
        }
      } else if (t === "object") {
        for (let i in data) {
          o[i] = v.deepCopy(data[i]);
        }
      }
      return o;
    },
    typeOf(obj) {
      let map = {
        "[object Boolean]": "boolean",
        "[object Number]": "number",
        "[object String]": "string",
        "[object Function]": "function",
        "[object Array]": "array",
        "[object Date]": "date",
        "[object RegExp]": "regExp",
        "[object Undefined]": "undefined",
        "[object Null]": "null",
        "[object Object]": "object"
      };
      return map[Reflect.toString.call(obj)];
    },
    /**
     * 转html实体
     * */
    entityToString(entity) {
      let div = document.createElement("div");
      div.innerHTML = entity;
      return div.innerText || div.textContent;
    },
    // 判断页面操作按钮权限
    getPermission(name) {
      const v = this;
      if (v.isAdmin) return true;
      if (!name) return false;
      const roleList = commonLocalStorage.getItem('roleList') || v.$store.state.roleList || {};
      // roleList 有值：优先直接用 roleList
      if (Object.keys(roleList).length > 0) {
        if (roleList[name]) return true;
        const pagePermissionsList = commonLocalStorage.getItem('pagePermissionsList') || {};
        if (!Object.keys(pagePermissionsList).length) return false;
        const to = v.$route;
        const menuKey = getRouteMenuKey(to, v.system);
        const roleData = pagePermissionsList[menuKey] || [];
        return roleData.includes(name);
      }
      // roleList 为空：缓存失效时
      const pagesPermissions = commonLocalStorage.getItem('pagesPermissions') || [];
      if (pagesPermissions.length > 0) {
        const paths = [];
        const stack = [...pagesPermissions];
        while (stack.length) {
          const item = stack.pop();
          if (!item) continue;
          if (item.path) paths.push(item.path);
          if (item.children && item.children.length) stack.push(...item.children);
        }
        if (paths.includes(v.$route.path)) {
          window.location.reload();
        }
        return false;
      }
      // 没 pagesPermissions时
      if (v.system === 'shopping') {
        if (v.userInfo && Object.keys(v.userInfo).length > 0 && !v.fromListing) {
          window.location.reload();
        }
        return false;
      }
      window.location.reload();
      return false;
    },
    // 判断页面的权限
    getPermissionCallback(name) {
      if (name === "") return;
      return new Promise((resolve) => {
        let v = this;
        let data = commonLocalStorage.getItem('roleData') || v.$store.state.roleData;
        if (data) {
          if (v.isAdmin || data.includes(name)) {
            resolve(true);
          } else {
            v.gotoError();
          }
        }
      });
    },
    // 排序的操作按钮
    modifyTheSort(index, status) {
      let v = this;
      v.pageParams.orderBy = v.buttonGroupModel[index].type;
      v.buttonGroupModel.forEach((n, i) => {
        if (i === index && n.selected) {
          v.buttonGroupModel[index].status = !v.buttonGroupModel[index].status;
        } else n.selected = i === index && !n.selected;
      });
      v.pageParams.upDown = v.buttonGroupModel[index].status ? "up" : "down";
      v.pageParamsStatus = true;
    },
    // 展开与收起检索条件
    toggleMoreFilter() {
      let v = this;
      if (v.moreFilter) {
        v.moreFilter = false;
        v.moreFilterMes = v.storeFilterMes;
        v.moreFilterIcon = "md-arrow-dropdown";
      } else {
        v.moreFilter = true;
        v.storeFilterMes === "" ? (v.storeFilterMes = v.moreFilterMes) : "";
        if (v.pageParams && v.pageParams.searchValue && v.pageParams.searchValue !== "") {
          v.pageParams.searchValue = "";
        }
        v.moreFilterMes = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000141');
        v.moreFilterIcon = "md-arrow-dropup";
      }
    },
    // 跳转到无权限页面
    gotoError() {
      this.$router.push("/noPersermission");
    },
    // 获取物流方式
    loadData(item, callback) {
      item.loading = true;
      let v = this;
      let url = "";
      // 不关联仓库查询
      if (item.notAssociated) {
        url = api.get_enableShippingMethods + `?carrierId=${item.value}`;
      }
      // 关联仓库查询
      else {
        url = api.get_enableShippingMethods + `?carrierId=${item.value}&warehouseId=${item.warehouseId}`;
      }
      let pos = [];
      v.axios.get(url).then((response) => {
        if (response.data.code === 0) {
          let data = response.data.datas || [];
          if (data.length > 0) {
            v.shippingMethodsList = data;
            for (let i = 0; i < data.length; i++) {
              let carrierShippingMethodName = _handleMultilingualFields(data[i].carrierShippingMethodName);
              pos.push({
                value: [data[i].shippingMethodId, item.carrierAccounts],
                label: carrierShippingMethodName
              });
              if (i === data.length - 1) {
                item.children = pos;
                item.loading = false;
                callback();
              }
            }
          }
          if (data.length === 0) {
            item.children = pos;
            item.loading = false;
            v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000142'));
            callback();
          }
        } else {
          item.loading = false;
          item.children = [];
        }
      }).catch(() => {
        item.loading = false;
        item.children = [];
      });
    },
    showShippingData(value, notAssociated, isOnline, ymsWarehouseId, carrierType) {
      if (value) {
        this.getShippingList(notAssociated, isOnline, ymsWarehouseId, carrierType);
      }
    },
    getShippingList(notAssociated, isOnline, ymsWarehouseId, carrierType) {
      let v = this;
      let url = "";
      let warehouseId = ymsWarehouseId || getWarehouseId();
      // 不关联仓库查询
      if (notAssociated) {
        if (isOnline === 0 || isOnline === 1) {
          let query = `?isOnline=${isOnline}`;
          if (!isValueEmpty(carrierType)) {
            query = `?isOnline=${isOnline}&carrierType=${carrierType}`;
          }
          url = api.get_enableCarriers + query;
        } else {
          url = api.get_enableCarriers;
        }
      }
      // 关联仓库查询邮寄方式
      else {
        url = api.get_enableCarriers + "?warehouseId=" + warehouseId + "&isFilter=true" + "&time=" + new Date().getTime();
      }
      v.axios.get(url).then((response) => {
        if (response.data.code === 0) {
          let data = response.data.datas || [];
          if (data.length > 0) {
            v.carrierList = data;
            let pos = [];
            for (let i = 0; i < data.length; i++) {
              let carrierName = _handleMultilingualFields(data[i].carrierName);
              pos.push({
                value: data[i].carrierId,
                label: carrierName,
                children: [],
                loading: false,
                carrierAccounts: data[i].carrierAccounts,
                notAssociated: notAssociated,
                warehouseId: warehouseId,
                isOnline: data[i].isOnline,
              });
              if (i === data.length - 1) {
                if (isOnline === 0) {
                  v.shippingMethodData = pos.filter((item) => {
                    return item.isOnline === isOnline;
                  });
                } else {
                  v.shippingMethodData = pos;
                }
              }
            }
          }
        }
      });
    },
    // 获取物流方式的动态参数
    getCarrierBaseSettingApiMatch(shippingMethodId, model) {
      const v = this;
      v.carrierBaseSetting = [];
      v[model ? model : 'shippingMethodModel'] = [];
      let url = `${api.get_carrierParam_queryForShippingMethodParams}?shippingMethodId=${shippingMethodId}&time=${Date.now() + Math.random() * 100}`;
      v.axios.get(url).then((response) => {
        if (response.data.code === 0) {
          const data = response.data.datas || [];
          const targetArray = model ? v[model] : v.shippingMethodModel;
          targetArray.push(...data.map(n => ({
            paramKey: n.paramKey,
            paramValue: n.paramValue,
            title: n.paramName
          })));
          v.carrierBaseSetting = data;
        }
      });
    },
    // 校验密码不能输入中文 (默认校验密码必填，required 为false时，不校验密码必填) 可共用
    validatePasswordnoMatchChinese(required = true) {
      let v = this;
      let isnoMatchChinese = v.$regular.noMatchChinese;
      return function (rule, value, callback) {
        if (required) {
          if (value === "") {
            callback(new Error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000143')));
          } else if (isnoMatchChinese.test(value)) {
            callback(new Error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000144')));
          }
        } else {
          if (value && isnoMatchChinese.test(value)) {
            callback(new Error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000144')));
          }
        }
        callback();
      };
    },
    // 校验邮箱格式 (默认校验邮箱必填，required 为false时，不校验邮箱必填) 可共用
    validateMailboxFormat(required = true) {
      let v = this;
      let isMailbox = v.$regular.isMailbox;
      return function (rule, value, callback) {
        if (required) {
          if (value === "") {
            callback(new Error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000145')));
          } else if (!isMailbox.test(value)) {
            callback(new Error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000146')));
          }
        } else {
          if (value && !isMailbox.test(value)) {
            callback(new Error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000146')));
          }
        }
        callback();
      };
    },
    // 校验手机号 可共用
    validateMobile(required = true) {
      let v = this;
      let isPhone = v.$regular.isPhone;
      return function (rule, value, callback) {
        if (required) {
          if (!value) {
            return callback(new Error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000147')));
          } else if (!isPhone.test(value)) {
            return callback(new Error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000148')));
          }
        } else {
          if (value && !isPhone.test(value)) {
            return callback(new Error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000148')));
          }
        }
        callback();
      };
    },
    
    // 校验区号+手机号 可共用
    validateOverseasMobile(required = true) {
      let v = this;
      let AllNumber = v.$regular.AllNumber;
      return function (rule, value, callback) {
        if (required) {
          if (!value) {
            return callback(new Error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000147')));
          } else if (!AllNumber.test(value)) {
            return callback(new Error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000149')));
          }
        } else {
          if (value && !AllNumber.test(value)) {
            return callback(new Error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000149')));
          }
        }
        callback();
      };
    },
    
    // 校验固定电话 可共用
    validateFixedTelephone() {
      let v = this;
      let fixedTelephone = v.$regular.fixedTelephone;
      return function (rule, value, callback) {
        if (value && !fixedTelephone.test(value)) {
          return callback(new Error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000150')));
        } else {
          callback();
        }
      };
    },
    
    // 校验省市区地址
    validateCascaderAddressValue() {
      return function (rule, value, callback) {
        if (!value || value.length <= 0) {
          callback(new Error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000151')));
        } else {
          if (value.length < 3) {
            callback(new Error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000152')));
          } else {
            callback();
          }
        }
      };
    },
    
    // 删除的模态框模板
    isDelModal(okCallback, cancelCallback, text) {
      let v = this;
      let content = text || aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000153');
      v.$Modal.confirm({
        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000154'), content: "<p>" + content + "</p>", onOk: () => {
          okCallback && okCallback();
        }, onCancel: () => {
          cancelCallback && cancelCallback();
        }
      });
    },
    processObjTime(obj, paramsList) {
      paramsList.forEach((val) => {
        if (obj[val]) obj[val] = this.$uDate.dealTime(obj[val], "fulltime");
      });
      return obj;
    },
    processTimeData(list, key) {
      if (typeof key === "string") {
        list.forEach((val) => {
          if (val[key]) val[key] = this.$uDate.dealTime(val[key], "fulltime");
        });
      } else if (Array.isArray(key)) {
        list.forEach((val) => {
          key.forEach((item) => {
            val[item] = val[item] ? this.$uDate.dealTime(val[item], "fulltime") : "";
          });
        });
      }
      return this.handleMultilinguaTableFields(list, ["goodsCnDesc"]);
    },
    priceTransform(price) {
      if (price) {
        let num = price + "";
        if (num.includes(".")) {
          let arr = num.split(".");
          return arr[0].replace(/\B(?=(\d{3})+$)/g, ",") + "." + arr[1];
        } else {
          return num.replace(/\B(?=(\d{3})+$)/g, ",");
        }
      } else {
        return 0;
      }
    },
    
    /**
     * @Description: 当前系统的图片，有时候加载失败，对加载失败的图片进行优化处理，加载失败时，默认展示加载失败的默认图
     * @author jing
     * @date 2021/9/15 17:09
     * @params:
     */
    setErrorImg(event) {
      let img = event.srcElement;
      img.src = require("@/assets/images/imageError.jpg");
      img.onerror = null;
    },
    /**
     * @Description:  websocket连接后台服务实时更新消息通知的数据
     * @author jing
     * @date 2021/12/10 17:22
     * @params:
     */
    getMessageNotificationData(url) {
      let v = this;
      v.axios.get(url).then((response) => {
        if (response.data.code === 0) {
          let data = response.data.datas || [];
          let messageReminderList = [];
          if (data.length > 0) {
            data.map((item) => {
              item.timer = v.$uDate.dealTime(item.updatedTime, "fulltime");
            });
            if (data.length >= 5) {
              messageReminderList = data.slice(0, 5);
            } else {
              messageReminderList = data;
            }
          }
          v.$store.commit("unreadTotal", data.length);
          v.$store.commit("unreadData", messageReminderList);
        }
      });
    },
    /**
     * @Description: 打印的公共方法
     * @author jing
     * @date 2022/1/11 14:11
     * @params: val 链接地址  postId  打印的包裹号  text  打印成功之后的提示文本
     */
    commonPrint(val, postId, text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000155')) {
      let v = this;
      return new Promise((resolve) => {
        printHtmlUrl(val, postId).then((res) => {
          if (res.printType === "cainiao") {
            v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000156') + "：" + postId + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000155'));
            return;
          }
          val = res;
          if (val.content) {
            val.content = encodeURIComponent(val.content);
          } else {
            val.pdf = encodeURIComponent(val.pdf);
          }
          let instance = v.axios.create({
            timeout: 5000,
            headers: {
              "Content-Type": "multipart/form-data; charset=UTF-8"
            }
          });
          delete v.axios.defaults.headers.post["X-Requested-With"];
          instance.post("http://localhost:10099/print", qs(val), {noLanguage: true}).then((response) => {
            if (response.status === 200) {
              v.$Message.success(text);
              resolve(true);
            }
          }).catch((err) => {
            console.log('-------打印失败-----', err);
            let fileName = "/tool/TongtoolPrinter.exe";
            downloadControl(fileName).then(() => {
              v.tableLoading = false;
            });
          });
        });
      });
    },
    /**
     * @Description: 打印文档内容htmlText的公共方法
     * @author jing
     * @date 2022/2/9 10:57
     * @params: service：对应的系统服务,  htmlText：打印的文本内容
     */
    publicPrintBtn(service, htmlText) {
      let v = this;
      return new Promise((resolve) => {
        let path = `${window.location.origin}/${service}/static/printFont/`;
        let htm5Doc = `<!DOCTYPE html>
                  <html lang="en">
                    <head>
                    <meta charset="UTF-8">
                    <title>Title</title>
                    <style type="text/css">
                    *{margin: 0;padding: 0;color: #000000;outline:0}
                @media print {.btn{display: none;}}
                  @font-face {
                  font-family: 'IDAutomationC128S';
                  src: url('${path}IDAutomationC128S.eot'); /* IE9 Compat Modes */
                  src: url('${path}IDAutomationC128S.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
                  url('${path}IDAutomationC128S.woff') format('woff'), /* Modern Browsers */
                  url('${path}IDAutomationC128S.ttf') format('truetype'), /* Safari, Android, iOS */
                  url('${path}IDAutomationC128S.svg#IDAutomationC128S') format('svg'); /* Legacy iOS */
                }

                @font-face {
                  font-family: 'IDAutomationSC39S';
                  src: url('${path}IDAutomationSC39S.eot'); /* IE9 Compat Modes */
                  src: url('${path}IDAutomationSC39S.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
                  url('${path}IDAutomationSC39S.ttf') format('truetype');
                }
                </style>
                    </head>
                     <body class="box">` + htmlText + `
                     </body>
                  </html>`;
        let instance = v.axios.create({
          timeout: 3000, transformRequest: [function (data) {
            let ret = "";
            for (let it in data) {
              ret += encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
            }
            return ret;
          }], headers: {
            "Content-Type": "application/x-www-form-urlencoded"
          }
        });
        instance.post("http://localhost:10099/print", {content: htm5Doc, postId: "1"}).then((response) => {
          if (response.status === 200) {
            v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000155'));
            resolve(true);
          }
        }).catch(() => {
          let fileName = "/tool/TongtoolPrinter.exe";
          downloadControl(fileName).then(() => {
            v.tableLoading = false;
          });
          resolve(true);
        });
      });
    },
    /**
     * @Description: 批量生成售卖资料的公共方法
     * @author jing
     * @date 2023/6/7 9:48
     * @params:
     */
    generateSalesInfoFun(type, ymsProductId, merchantId, listingStatus, currentlySelectedData) {
      let v = this;
      let query = {
        distributorMerchantId: merchantId, type: Number(listingStatus), ymsProductIds: []
      };
      // 批量
      if (type === "all") {
        if (currentlySelectedData.length > 0) {
          query.ymsProductIds = currentlySelectedData.map((item) => {
            return item.ymsProductId;
          });
          if (v.generationTalg) {
            query.isRegeneration = v.isRegeneration;
            query.isBatchType = 1; // 是否是批量
            handleGenerateSalesInforAlertsData(query, type);
          } else {
            v.$Modal.confirm({
              title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000157'),
              content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000158'),
              okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000159'),
              cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000112'),
              onOk: () => {
                query.isBatchType = 1; // 是否是批量
                handleGenerateSalesInforAlertsData(query, type);
              },
              onCancel: () => {
              }
            });
          }
        } else {
          v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000160'));
          return false;
        }
      }
      // 点击单个
      else if (type === "single") {
        query.ymsProductIds = [ymsProductId];
        v.$Modal.confirm({
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000157'),
          content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000158'),
          okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000159'),
          cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000112'),
          onOk: () => {
            handleGenerateSalesInforAlertsData(query, type);
          },
          onCancel: () => {
          }
        });
      }
      
      // 处理生成售卖资料
      function handleGenerateSalesInforAlertsData(query, type) {
        v.axios.post(api.post_ymsDistributorProductInfo_product, query).then((response) => {
          if (response.data.code === 0) {
            if (type === "all") {
              v.generationTalg = false;
              v.generateSalesInforAlertsModal = false;
            }
            let data = response.data.datas;
            if (data) {
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000161'));
            }
          }
        });
      }
    },
    /**
     * @Description: 在运营、分销商、供应商系统点击商品名称跳转到商城的商品详情页
     * @author jing
     * @date 2022/7/18 15:41
     * @params: ymsProductId
     */
    // 点击中文名称跳转到商城详情页
    toShopDetails(ymsProductId, type) {
      if (ymsProductId) {
        let systemList = ["yms", "distributor", "supplier"];
        if (systemList.includes(this.system)) {
          let talg = window.location.href.split("//");
          let url = `/index.html#/shopDetails/${ymsProductId}`;
          if (type) {
            url = url + type;
          }
          if (talg[1].includes("localhost")) {
            let link = `${talg[0]}//${window.location.host}${url}`;
            window.open(link, "_blank");
          } else {
            let link = `${talg[0]}//${window.location.host}/yms-shopping-service/${url}`;
            window.open(link, "_blank");
          }
        }
      }
    },
    /**
     * @Description: 强密码生成
     * @author jing
     * @date 2022/8/9 16:12
     * @params:
     */ getStrongPassword(obj, value) {
      let v = this;
      const length = 16;
      let chars;
      if (!chars) chars = "abcdefghijkmnpqrstuvwxyzABCDEFGHJKMNPQRSTUVWXYZ23456789*&%$#@!";
      let randomChars = "";
      for (let x = 0; x < length; x++) {
        let i = Math.floor(Math.random() * chars.length);
        randomChars += chars.charAt(i);
      }
      v[obj][value] = randomChars;
      v.$nextTick(() => {
        v.getFocus(obj + "_" + value);
      });
    },
    /**
     * @Description: 默认设置时间段筛选的开始、结束时间的时分秒为00:00:00  23:59:59
     * @author jing
     * @date 2022/9/21 9:52
     * @params: value 时间段  talg: 是否转换格式符号， 默认转换
     */
    defaultTimePeriod(value, talg = true) {
      if (talg) {
        let newTimer = [];
        let start = value[0].replace(/-/g, "/");
        let end = value[1].replace(/-/g, "/");
        if (start.includes("00:00:00")) {
          newTimer[0] = start.slice(0, -8) + "00:00:00";
        } else {
          newTimer[0] = start;
        }
        if (end.includes("00:00:00")) {
          newTimer[1] = end.slice(0, -8) + "23:59:59";
        } else {
          newTimer[1] = end;
        }
        return newTimer;
      } else {
        if (value[1].slice(-8) === "00:00:00") {
          value[1] = value[1].slice(0, -8) + "23:59:59";
        }
        return value;
      }
    },
    
    /**
     * @Description: 默认的时间段条件查询的范围
     * @author jing
     * @date 2022/11/15 11:07
     * @params:
     * days 默认查询的时间范围天数
     * value 时间选择器值变量
     * startTimeKey、endTimeKey 筛选时间段的key
     */
    defaultTimePeriodRange(days, value, startTimeKey, endTimeKey) {
      let v = this;
      let end = new Date();
      let start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * days);
      // 设置开始时间的时分秒为 00:00:00
      start.setHours(0, 0, 0, 0);
      // 设置结束时间的时分秒为 23:59:59
      end.setHours(23, 59, 59, 999);
      let startTime = v.$uDate.getDateTime(start, "fulltime");
      let endTime = v.$uDate.getDateTime(end, "fulltime");
      v[value] = [startTime, endTime];
      v.pageParams[startTimeKey] = v.$uDate.getUniversalTime(startTime, "fulltime");
      v.pageParams[endTimeKey] = v.$uDate.getUniversalTime(endTime, "fulltime");
    },
    /**
     * @Description: 处理币种符号的问题(商城)
     * @author jing
     * @date 2022/11/21 16:51
     * @params: currency 币种
     */
    currencySymbol(currency) {
      let currencyData = commonLocalStorage.getItem('currencyData') || [];
      let currencySymbol = "";
      if (currencyData.length > 0) {
        currencyData.map((item) => {
          if (item.currencyCode === currency) {
            currencySymbol = item.currencySymbol;
          }
        });
      }
      return currencySymbol ? " " + currencySymbol + " " : " ";
    },
    
    /**
     * @Description: 获取指定尺寸大小的缩略图方法
     * @author jing
     * @date 2023/1/10 16:01
     * @params:
     * imagePath 当前原图的路径
     * size 尺寸大小(默认获取400*400的尺寸的缩略图)
     * thumbnailPath 指定缩略图大小的路径
     * isTableImg 是否列表图片
     */
    getThumbnailImage(imagePath, thumbnailPath = "/thumb/", imgSize, isTableImg) {
      let imgUrl = "";
      let size = imgSize ? imgSize : "400x400";
      let thumbnailImg = thumbnailPath + size;
      let pathLiast = [
        "/index", "/shopList", "/shopDetails", "/productList", "/productDetails",
        "/productCenter/productGoods", "/newProductReviewList", "/productReviewForSaleList",
        "/newProductReviewDetails","/productReviewForSaleDetails",
        "/wms/inventoryLevels", "/commodityList", "/commoditySortingOperation"
      ];
      const handleImg = (imagePath, thumbnailPath, size) => {
        // 获取完整图片地址
        const fullUrl = imagePath?.startsWith('http') ? imagePath : this.setImgPath(imagePath, null, null, isTableImg, false);
        // 非 http 地址（占位图/base64 等）直接返回
        if (!fullUrl?.startsWith('http')) {
          return fullUrl;
        }
        const splitTag = '/filenode/s';
        const [prefix, suffix] = fullUrl.split(splitTag);
        // 无法拆分则返回原图
        if (!suffix) {
          return fullUrl;
        }
        return `${prefix}${splitTag}${thumbnailPath}${size}${suffix}`;
      };
      if (imagePath) {
        // 如果是手动上传的图片还是拿原图，如果当前图片是缩略图就不处理
        let path = this.$route.path;
        let name = this.$route.name;
        if (!(imagePath.includes("http://") || imagePath.includes("https://")) || imagePath.includes(thumbnailImg)) {
          if (this.system === "supplier" || imgSize) {
            if (!imagePath.includes(thumbnailImg)) {
              if (!imagePath.includes("/temp/")) {
                imgUrl = handleImg(imagePath, thumbnailPath, size);
              } else {
                imgUrl = imagePath;
              }
            } else {
              imgUrl = imagePath;
            }
          } else {
            imgUrl = imagePath;
          }
        }
        // 涉及到商品图片的才换成缩略图、列表涉及到图片的
        else if (pathLiast.includes(path) || pathLiast.includes(name) || isTableImg || imgSize) {
          imgUrl = handleImg(imagePath, thumbnailPath, size);
        } else {
          imgUrl = imagePath;
        }
      }
      return imgUrl;
    },
    /**
     * @Description: 处理下拉框批量操作按钮没有权限隐藏问题
     * @author jing
     * @date 2023/3/22 9:37
     * @params:
     */
    batchButtonPermissions(permissionKeyList) {
      let roleList = this.$store.state.roleList;
      if (this.isAdmin) {
        return true;
      } else {
        if (permissionKeyList.length > 0) {
          return permissionKeyList.some((item) => {
            return roleList[item.permissionKey];
          });
        }
      }
    },
    /**
     * @Description: 处理金额格式按照千分位显示
     * @author jing
     * @date 2023/4/14 15:21
     * @params: digitNum 千分位展示时，默认保留两位小数点，不足时自动补0
     */
    formatCurrency(value, digitNum = 2) {
      let amount = 0;
      if (value) {
        let val = Number(value);
        let obj = {
          minimumFractionDigits: digitNum, // 表示数字小数部分的最小位数，不足位数时后面用 0 补齐。
          maximumFractionDigits: digitNum // 表示数字小数部分的最大位数，超过位数时四舍五入。
        };
        const formatter = new Intl.NumberFormat("en-US", obj);
        amount = formatter.format(val);
      }
      return amount;
    },
    /**
     * @Description: 校验列表中在指定的宽度和文本限制行数下是否有文本内容溢出，如果有文本溢出则用Tooltip提示
     * @author jing
     * @date 2023/6/19 11:46
     * @params:
     * text  文本内容
     * width 列表中单元格指定的宽度
     * maxLines 文本限制的行数，默认限制两行
     * colorStyle 文本显示的颜色
     */
    checkContentOverflow(h, text, width, maxLines = 2, options = {}) {
      let isOverflow = false;
      let {
        colorStyle,
        boxStyles = {},
      } = options;
      if (text) {
        const hiddenDiv = document.createElement("div");
        hiddenDiv.style.visibility = "hidden";
        hiddenDiv.style.fontSize = "12px";
        hiddenDiv.style.width = `${width - 40}px`;
        hiddenDiv.innerText = text;
        hiddenDiv.style.wordWrap = "break-word";
        hiddenDiv.style.wordBreak = "break-all";
        document.body.appendChild(hiddenDiv);
        const lineHeight = parseInt(getComputedStyle(hiddenDiv).lineHeight);
        const maxHeight = lineHeight * maxLines;
        isOverflow = hiddenDiv.offsetHeight > maxHeight;
        document.body.removeChild(hiddenDiv);
      }
      let Tooltip = h("Tooltip", {
        props: {
          placement: "top", maxWidth: 400, transfer: true
        }
      }, [
        h("div", {
          class: `ellipsis_${maxLines} mt5 mb5`,
          style: boxStyles,
        }, text),
        h("div", {
          slot: "content", style: {
            whiteSpace: "normal", wordBreak: "break-all"
          }
        }, text)
      ]);
      let ordinary = h("div", {
        style: {
          color: colorStyle
        },
        class: 'mt5 mb5'
      }, text);
      return isOverflow ? Tooltip : ordinary;
    },
    /**
     * @Description: 系统默认选中的语种
     * @author jing
     * @date 2023/7/13 10:55
     * @params:
     */
    systemDefaultLanguage() {
      let v = this;
      return new Promise((resolve) => {
        let obj = MULTILINGUALNAMESLIST;
        let newList = [];
        const data = commonLocalStorage.getItem('configureLanguage') || v.$store.state.configureLanguage || [];
        if (data.length > 0) {
          data.map((item) => {
            newList.push({
              value: item.code, // CN US
              code: item.name, // zh-CN
              name: item.name,
              title: obj[item.name] || "",
              required: item.name === "zh-CN"
            });
          });
          v.multilingualNamesList = newList;
        }
        resolve(true);
      });
    },
    /**
     * @Description: 多语种单个入参的处理
     * @author jing
     * @date 2023/7/10 14:53
     * @params:
     * 当前多语种命名的字段的格式：multilingualName_ + 多语种的类型   例：multilingualName_zh-CN 中文名称的字段
     * 以json的形式传给后台  例：name:{'zh-CN': '中文名称', 'en-US': '英文名称'}
     */
    handleMultilingualSingleParam(obj, fields) {
      let names = {};
      if (Object.keys(obj).length > 0) {
        for (let key in obj) {
          if (key.includes(fields)) {
            let type = key.split(fields)[1];
            if (type) {
              names[type] = obj[key] || "";
            }
          }
        }
      }
      return JSON.stringify(names);
    },
    
    /**
     * @Description: 多语种多个入參的处理
     * @author jing
     * @date 2023/7/20 10:27
     * @params:
     */
    handleMultilingualMultipleParam(obj, keyList) {
      let v = this;
      if (Object.keys(obj).length > 0) {
        let reg = new RegExp("^(" + keyList.join("|") + ")");
        let params = Object.keys(obj).reduce((acc, key) => {
          if (!key.match(reg)) {
            acc[key] = obj[key];
          }
          return acc;
        }, {});
        keyList.map((item) => {
          let key = item.split("_")[0];
          params[key] = v.handleMultilingualSingleParam(obj, item);
        });
        return params;
      }
    },
    /**
     * @Description: 表单多语种出参赋值的统一处理
     * @author jing
     * @date 2023/7/20 10:46
     * @params:
     */
    handleMultilingualFormFields(data, keylist) {
      let form = {};
      keylist.map((key) => {
        if (data[key]) {
          if (isJSON(data[key])) {
            let obj = JSON.parse(data[key]);
            for (let k in obj) {
              form[key + "_" + k] = obj[k] || "";
            }
          }
          // 当没有配置多语种就默认展示中文值
          else {
            form[key + "_zh-CN"] = data[key];
          }
        } else {
          form[key + "_zh-CN"] = "";
        }
      });
      return form;
    },
    /**
     * @Description: 列表中多个字段多语种出参赋值的统一处理
     * @author jing
     * @date 2023/7/20 11:19
     * @params:
     */
    handleMultilinguaTableFields(data, keyList, value) {
      let v = this;
      if (data && data.length > 0) {
        data.map((item) => {
          for (let key in item) {
            if (keyList.includes(key)) {
              item[key] = _handleMultilingualFields(item[key], value);
            }
          }
        });
        return data;
      }
    },
    /**
     * @Description: 初始化多语种名称表单校验的字段名
     * @author jing
     * @date 2023/7/10 16:55
     * @params: 默认拼接 multilingualName_  例： multilingualName_zh-CN  中文名称字段
     */
    initMultilingualFields(fields, val, keyList) {
      let v = this;
      return new Promise((resolve) => {
        v.systemDefaultLanguage().then(() => {
          let obj = JSON.parse(JSON.stringify(val));
          if (v.multilingualNamesList.length > 0) {
            v.multilingualNamesList.map((item) => {
              if (keyList.length > 0) {
                keyList.map((key) => {
                  let type = key + item.code;
                  obj[type] = "";
                });
              } else {
                obj[item.code] = "";
              }
            });
          }
          v[fields] = obj;
          resolve(obj);
        });
      });
    },
    /**
     * @Description: 处理动态多语种日志的展示问题
     * @author jing
     * @date 2023/7/25 14:05
     * @params: 多语种日志--目前只处理分销商系统涉及的日志信息
     */
    handleMultilingualLogs(tableData, system) {
      if (tableData.length > 0) {
        tableData.map((item) => {
          let content = item.content;
          if (item.contentType !== 0 && item.contentType !== null) {
            if (isJSON(content)) {
              let text = JSON.parse(content);
              let newText = dynamicLog(text, item.contentType, system);
              if (newText) {
                item.logContent = newText.split(";");
              } else {
                item.logContent = text;
              }
            } else {
              // 在分销商系统需要屏蔽的动态日志类型
              let distributorDynamicLogsList = [45, 49];
              if (system === "distributor") {
                if (distributorDynamicLogsList.includes(item.contentType)) {
                  item.logContent = "";
                } else {
                  if (item.contentType === 44) {
                    item.logContent = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000162');
                  } else {
                    item.logContent = dynamicLog({}, item.contentType, system);
                  }
                }
              } else {
                item.logContent = dynamicLog({}, item.contentType, system);
              }
            }
          } else {
            item.logContent = item.content;
          }
        });
      }
      return tableData;
    },
    /**
     * @Description: 根据国家的twoCode(二次码)获取对应国家的省/洲市区的基础数据
     * @author jing
     * @date 2023/8/2 16:53
     * @params: twoCode
     */
    getProvinceBasicData(twoCode) {
      let v = this;
      let newData = [];
      let url = "";
      // 供应商入驻得先暂时走供应商服务调接口
      if (v.$route.path === "/supplierSettlement") {
        url = "/yms-supplier-service/erpCommon/yms-core-service/common/country/getDetailByTwoCode/";
      } else {
        url = api.get_common_country_getDetailByTwoCode;
      }
      return new Promise((resolve) => {
        v.axios.get(url + twoCode, {loading: true}).then((response) => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            if (data) {
              function replaceChildren(obj) {
                for (const key in obj) {
                  if (typeof obj[key] === "object") {
                    if (Array.isArray(obj[key])) {
                      obj[key].forEach((item) => replaceChildren(item));
                      if (["states", "cities", "districts"].includes(key)) {
                        // 将states、cities、districts替换为children
                        obj["children"] = JSON.parse(JSON.stringify(obj[key]));
                        delete obj[key];
                      }
                    }
                  }
                }
              }
              
              replaceChildren(data);
              newData = data.children || [];
              v.flatOutProvincialMunicipalAndDistrictData(newData);
              resolve(newData);
            }
          }
        });
      });
    },
    /**
     * @Description: 处理平铺之后的省市区数据
     * @author jing
     * @date 2025/4/17 10:10
     * @params:
     */
    flatOutProvincialMunicipalAndDistrictData(newData) {
      function treeToList(tree, result = []) {
        tree.forEach((node) => {
          result.push(node);
          node.children && treeToList(node.children, result);
        });
        return result;
      }
      
      let list = treeToList(newData);
      if (list.length > 0) {
        list.map((item) => {
          item.value = item.code;
          item.label = item.cnName;
        });
      }
      return list;
    },
    /**
     * @Description: 获取省市区的名称
     * @author jing
     * @date 2023/8/3 11:20
     * @params:
     */
    handleAddressName(obj, newData) {
      let v = this;
      let stateName = "";
      let cityName = "";
      let districtName = "";
      let addressName = "";
      let tileBasisAddressData = v.flatOutProvincialMunicipalAndDistrictData(newData);
      if (tileBasisAddressData.length > 0) {
        tileBasisAddressData.map((item) => {
          if (item.code === obj.state) {
            stateName = item.cnName;
          }
          if (item.code === obj.city) {
            cityName = item.cnName;
          }
          if (item.code === obj.district) {
            districtName = item.cnName;
          }
        });
        addressName = stateName + " / " + cityName + " / " + districtName;
      }
      return addressName;
    },
    /**
     * @Description: 处理自定义列的排序问题
     * @author jing
     * @date 2023/8/4 15:37
     * @params:
     * sortKeyList：当前列表已经设置展示的字段值
     * hideKeyColumns：根据需求屏蔽的列表字段
     * originalColumns：列表字段的原始数据
     * defaultSelectKeyList：列表默认展示的字段，不参与自定义列排序
     */
    handleCustomColumnsSort(sortKeyList, hideKeyColumns, originalColumns, defaultSelectKeyList) {
      let v = this;
      let newColumns = [];
      if (sortKeyList.length > 0) {
        originalColumns.map((item) => {
          if (!sortKeyList.includes(item.key)) {
            hideKeyColumns.push(item.key);
          }
        });
        hideKeyColumns = v.uniqueFunc(hideKeyColumns);
        newColumns = originalColumns.filter((item) => {
          return !hideKeyColumns.includes(item.key);
        });
        newColumns.sort((a, b) => sortKeyList.indexOf(a.key) - sortKeyList.indexOf(b.key));
        defaultSelectKeyList.map((key, idx) => {
          originalColumns.map((item) => {
            if (item.key === key) {
              if (idx <= 1) {
                newColumns.unshift(item);
              } else {
                newColumns.push(item);
              }
            }
          });
        });
      }
      let columns = v.uniqueFunc(newColumns, "key");
      return columns;
    },
    /**
     * @Description: 更新列表dom
     * @author jing
     * @date 2023/8/4 17:39
     * @params:
     */
    updateTableDom(dom, timer = 1000, scrollTalg = true, tableListKey = "tableData") {
      let v = this;
      v.$nextTick(() => {
        v.tableLoading = false;
      });
      if (v[tableListKey] && v[tableListKey].length > 0) {
        v.$nextTick(() => {
          setTimeout(() => {
            if (v.$refs[dom] && scrollTalg) {
              v.$refs[dom].$el.querySelector(".ivu-table-body").scrollTop = 0;
            }
            v[tableListKey] = [...v[tableListKey]];
          }, timer);
        });
        v.$forceUpdate();
      }
      v.$forceUpdate();
    },
    /**
     * @Description: 默认时间查询的公共方法
     * @author jing
     * @date 2023/8/22 14:39
     * @params:
     * type: last_month 最近一个月   three_months  最近三个月
     * selectValue: 下拉时间框的选项
     * fieldsType: '',   多个时间筛选框的字段
     */
    setDefaultTimerParams(type, selectValue, fieldsType) {
      let tagTimer = "";
      switch (type) {
        case "last_month":
          tagTimer = 3600 * 1000 * 24 * 30;
          break;
        case "three_months":
          tagTimer = 3600 * 1000 * 24 * 90;
          break;
      }
      let end = new Date();
      let start = new Date();
      start.setTime(start.getTime() - tagTimer);
      let startTime = this.$uDate.getDateTime(start, "fulltime");
      let endTime = this.$uDate.getDateTime(end, "fulltime");
      let time = [startTime, endTime];
      let setTimer = handleTime(time);
      
      function handleTime(value) {
        let newTimer = [];
        let start = value[0].replace(/-/g, "/");
        let end = value[1].replace(/-/g, "/");
        newTimer[0] = start.slice(0, -8) + "00:00:00";
        newTimer[1] = end.slice(0, -8) + "23:59:59";
        return newTimer;
      }
      
      if (selectValue) {
        this.selectTime({date: setTimer, value: selectValue});
      } else {
        this.getDateValue(setTimer, fieldsType);
      }
    },
    /**
     * @Description: 处理和组装地址模板数据
     * @author jing
     * @date 2023/10/10 15:33
     * @params:
     */
    getAddressTemplateData(type = "yms", merchantId) {
      const v = this;
      v.addressTemplateData = [];
      // 拼接 templateName
      const formatList = (list = []) => {
        return list.map(item => {
          const name =
            item.addressName + "<br/>" +
            item.name + " " + item.phone + "<br/>" +
            item.state + "<br/>" +
            item.city + "<br/>" +
            item.district + "<br/>" +
            item.street;
          return Object.assign({}, item, {templateName: name});
        });
      };
      
      // 通用请求封装，保持返回 Promise
      const requestPromise = (isPost, url, data) => {
        const req = isPost ? v.axios.post(url, data) : v.axios.get(url);
        return req.then(response => {
          if (response && response.data && response.data.code === 0) {
            const list = response.data.datas || [];
            v.addressTemplateData = formatList(list);
          }
          return v.addressTemplateData;
        });
      };
      
      if (type === "yms") {
        const query = {
          addressName: "",
          orderBy: "createdTime",
          status: 1,
          upDown: "down",
          servicePlatform: 'core',
        };
        return requestPromise(true, api.post_ymsAddressTemplate_chooseList, query);
      } else if (type === "supplier") {
        const query = {
          status: 1,
          templateMerchantId: merchantId,
          servicePlatform: 'supplier',
        };
        return requestPromise(true, api.post_ymsAddressTemplate_api_queryList, query);
      } else {
        return requestPromise(false, api.get_ymsAddressTemplate_api_chooseList);
      }
    },
    /**
     * @Description: 跳转到刊登系统的指定页面的方法
     * @author jing
     * @date 2023/11/3 14:12
     * @params: url  跳转到Listing的指定页面路径
     */
    goToListingPage(url) {
      let v = this;
      let path = "";
      let merchant = v.$store.state.erpConfig.merchant;
      if (merchant) {
        let listingDomain = merchant.listingDomain;
        let ymsListingDomain = merchant.ymsListingDomain;
        if (merchant.listingStatus === "1") {
          path = listingDomain + url;
        } else {
          path = ymsListingDomain + url;
        }
        path = path.includes("http") ? path : "https://" + path;
        window.open(path, "_blank");
      } else {
        v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000163'));
        return false;
      }
    },
    /**
     * @Description: Table列表自动滚动到顶部
     * @author jing
     * @date 2024/12/31 16:40
     * @params:
     */
    tableListScrollsTop(tableDom) {
      this.$nextTick(() => {
        if (this.$refs[tableDom]) {
          this.$refs[tableDom].$el.querySelector('.ivu-table-body').scrollTop = 0;
        }
      });
    },
    // 费用处理
    expenseProcessingFun(h, params, type, title) {
      const v = this;
      const ymsPackageCosts = params.row.ymsPackageCosts || [];
      const {total, currency, matched} = ymsPackageCosts.reduce(
        (acc, item) => {
          if (item.type === type) {
            acc.total += Number(item.amount || 0);
            if (!acc.currency && item.currency) acc.currency = item.currency;
            acc.matched = true; // 标记命中
          }
          return acc;
        },
        {total: 0, currency: '', matched: false}
      );
      // 没有匹配 || 金额为空 → 不展示
      if (!matched || isValueEmpty(total)) return '';
      return h('div', {class: 'flex flex-align-center'}, [
        h('span', title),
        h('span', v.formatCurrency(total)),
        h('span', {class: 'ml5'}, currency)
      ]);
    },
    // 下单提前校验余额是否充足公共方法
    orderVerificationOfUserBalance(obj) {
      let v = this;
      let configurationItemInfo = commonLocalStorage.getItem('configurationItemInfo') || v.$store.state.configurationItemInfo;
      let onlineBalanceRechargeTalg = configurationItemInfo?.onlineBalanceRecharge || false;
      return new Promise((resolve, reject) => {
        let content = '';
        checkUserBalance(obj).then((val) => {
          // 余额充足
          if (val) {
            content = `
              <p>
                ${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000125')}<span class="distributorThemeColor">${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000126')}</span>！<br/>
                ${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000127')}
              </p>`;
          }
          // 余额不足
          else {
            if (onlineBalanceRechargeTalg) {
              content = `
                <p>
                  ${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000125')}<span class="crimsonColor">${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000128')}</span>！
                  <span id="clickToRecharge" class="distributorThemeColor cursor text-decoration ml2">${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000129')}</span>
                  <span>${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000130')}</span><br/>
                  ${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000131')}
                  <span class="distributorThemeColor">${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000132')}</span>
                </p>`;
            } else {
              content = `
                <p>
                  ${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000125')}<span class="crimsonColor">${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000128')}</span>！
                  <span>${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000130')}</span><br/>
                  ${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000131')}
                  <span class="distributorThemeColor">${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000132')}</span>
                </p>`;
            }
          }
          
          // 绑定 Modal 内容里的点击事件
          let observer = null;
          if (onlineBalanceRechargeTalg) {
            observer = new MutationObserver(() => {
              const rechargeBtn = document.getElementById('clickToRecharge');
              if (rechargeBtn) {
                rechargeBtn.onclick = () => {
                  localStorage.setItem('openRechargeTalg', JSON.stringify(true));
                  if (v.system === 'distributor') {
                    const {href} = v.$router.resolve({
                      name: 'RechargeRecord'
                    });
                    window.open(href, '_blank');
                  } else {
                    pageJump(`/distributor.html#/rechargeRecord`, '/yms-distributor-service', '_blank');
                  }
                  v.$Modal.remove();
                  observer.disconnect();
                  reject('goRecharge');
                };
              }
            });
            observer.observe(document.body, {childList: true, subtree: true});
          }
          v.$Modal.confirm({
            title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000164'),
            content,
            width: 600,
            dangerouslyUseHTMLString: true,
            okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000111'),
            cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000112'),
            onOk: () => {
              if (onlineBalanceRechargeTalg) {
                observer.disconnect();
              }
              resolve(true);
            },
            onCancel: () => {
              if (onlineBalanceRechargeTalg) {
                observer.disconnect();
              }
              reject('cancel');
            }
          });
        });
      });
    },
  },
  watch: {
    $route: {
      handler() {
        let v = this;
        v.getPageSizeStorage();
      },
      immediate: true,
      deep: true
    }
  }
};
